import React, {useState} from 'react';
import {AuthLayout} from "../../core/layout/AuthLayout";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from '@fullcalendar/interaction';
import itLocale from '@fullcalendar/core/locales/it';
import {useSelector} from "react-redux";
import {selectSelectedPharmacy} from "../../core/reducer/pharmacySlice";
import http from "../../shared/utils/http";

import EventCalendar from "./components/EventCalendar";
import {padNumber} from "../../shared/utils/dateUtils";
import {useEffectOnlyUpdate} from "../../shared/utils/use_custom/useEffectOnlyUpdate";
import useCalendarInitDestroy from "./useCustom/useCalendarInitDestroy";
import useFestiveCalendar from "./useCustom/useFestiveCalendar";
import {EventMountArg} from "@fullcalendar/core";


export function CalendarEmployee() {
    const [selectedRange, setSelectedRange] = useState<any>(null);
    const pharmacy = useSelector(selectSelectedPharmacy)
    const [events, setEvents] = useState<any[]>([])
    const {calendarRef, currentViewCalendar, setCurrentViewCalendar} = useCalendarInitDestroy()

    const {dayCellClassNames} = useFestiveCalendar(pharmacy)

    const calendarCall = (startDate: Date, endDate: Date) => {
        http.get(`pharmacies/${pharmacy?.idDocument}/hours/${startDate.getFullYear()}/${startDate.getMonth()}/${startDate.getDate()}/${endDate.getFullYear()}/${endDate.getMonth()}/${endDate.getDate()}`).then(res => {
            const employee = res.employee
            setEvents((res.hours || []).reduce((acc: any[], evDay: any) => {
                const newData = (evDay.listUpdate || evDay.list).map((ev: any, index: number) => ({
                    id: evDay.idDocument + index,
                    title: employee.name,
                    extendedProps: {
                        type: ev.type,
                        idEmployee: evDay.idEmployee,
                        idPharmacy: evDay.idPharmacy,
                        idPharmacist: evDay.idPharmacist,
                        idDocument: evDay.idDocument,
                        edit: !!evDay.listUpdate,
                        index,
                    },
                    start: new Date(evDay.year, evDay.month, evDay.day, ev.start.hour, ev.start.minute),
                    end: new Date(evDay.year, evDay.month, evDay.day, ev.end.hour, ev.end.minute),
                    color: employee.color,

                }))
                return [...acc, ...newData]
            }, []))

        })
    }

    const changeDate = (arg: any) => {
        const dateEnd = new Date(arg.end)
        dateEnd.setMinutes(dateEnd.getMinutes() - 1)
        setSelectedRange({
            start: arg.start, // Data di inizio
            end: dateEnd,     // Data di fine
        });
        const calendarApi = (calendarRef?.current as any)?.getApi();
        const currentView = calendarApi?.view?.type;
        setCurrentViewCalendar(currentView)
        calendarCall(arg.start, dateEnd)
    }
    useEffectOnlyUpdate(() => {
        pharmacy && selectedRange && calendarCall(selectedRange.start, selectedRange.end)
    }, [pharmacy])

    const handleEventMount = (info: EventMountArg) => {
        info.el.style.borderLeft = `4px solid ${info.backgroundColor}`;
        info.el.style.backgroundColor = `${info.backgroundColor}88`;
    };


    return (
        <AuthLayout>
            <>
                {pharmacy ? <div className="row gap-2 pt-3">
                    <div className="col-12">
                        <div className={'h-100 '}>
                            <div className={'calendar-component'}>
                                <div className={'calendar-col-detail p-2'}>
                                    <FullCalendar
                                        ref={calendarRef}
                                        eventDidMount={handleEventMount}
                                        height={'100%'}
                                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                        initialView="timeGridWeek"

                                        editable={false} // Permette drag and drop
                                        droppable={false} // Permette drag and drop
                                        events={events}
                                        headerToolbar={{
                                            left: 'prev,next today',
                                            center: 'title',
                                            right: 'dayGridMonth,timeGridWeek,timeGridDay'
                                        }}
                                        slotMinTime="00:00:00" // Ora minima visualizzata
                                        slotMaxTime="23:59:59" // Ora massima visualizzata
                                        slotDuration="00:30:00" // Durata di ciascuno slot
                                        businessHours={pharmacy?.openingHours?.map(ele => ({
                                            daysOfWeek: [1, 2, 3, 4, 5, 6], // Lun-Sab
                                            startTime:
                                                `${padNumber(ele.start.hours)}:${padNumber(ele.start.minutes)}`,
                                            endTime:
                                                `${padNumber(ele.end.hours)}:${padNumber(ele.end.minutes)}`,
                                        }))}
                                        locale={itLocale} // Locale in italiano
                                        firstDay={1} // Inizio della settimana: Lunedì
                                        datesSet={changeDate}

                                        eventContent={(eventInfo) => (
                                            <EventCalendar eventInfo={eventInfo}/>
                                        )}
                                        eventShortHeight={80}
                                        slotEventOverlap={false}
                                        dayCellClassNames={dayCellClassNames}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : <div>Selezionare farmacia</div>}
            </>
        </AuthLayout>
    );
}


